import { EntityBase, IEntityBaseInfo } from "../entity/entitybase";
import { IMultiStatusInfo, MultiStatus } from "../multi-status/multi-status";
import { IMultiStatusConfigInfo, MultiStatusConfig } from "../multi-status/multi-status-config";

export interface IActivityInfo extends IEntityBaseInfo {

  Label?: string;
  Description?: string;
  HasAnalyticCode?: boolean;

  // client side properties
  IsAssociated?: boolean;
}

export class Activity extends EntityBase {

  Label?: string;
  Description?: string;
  HasAnalyticCode?: boolean;

  // client side properties
  IsAssociated?: boolean;   // This indicates whether or not the activity is associated to a business unit through the MultiStatusConfig component

  /**
   * Create an instance of Activity class.
   */
  constructor(info: IActivityInfo) {
    super(info);

    this.Label = info.Label;
    this.Description = info.Description;
    this.HasAnalyticCode = info.HasAnalyticCode ?? false;

    this.IsAssociated = info.IsAssociated ?? false;

    this.StatusConfig = this.buildStatusConfig();
    this.changeStyle();
  }

  override buildStatusConfig(): MultiStatusConfig {
    return new MultiStatusConfig(<IMultiStatusConfigInfo>{
      Statuses: [
        new MultiStatus(<IMultiStatusInfo>{
          Label: 'app.shared.active',
          Style: 'color: #FFFFFF; background-color: var(--purple-success)',
          Handler: () => { this.IsAssociated = true; this.changeStyle() },
        }),
        new MultiStatus(<IMultiStatusInfo>{
          Label: 'app.shared.inactive',
          Style: 'color: #434040; background-color: #FFFFFF',
          Handler: () => { this.IsAssociated = false; this.changeStyle() },
        })
      ]
    });
  }

  override changeStyle() {
    if (this.IsAssociated) {
      this.StatusConfig.Statuses[0].Style = "color: var(--card-bg); background-color: var(--purple-success)";
      this.StatusConfig.Statuses[1].Style = "color: var(--module-title); background-color: var(--dropdown-bg)";
    } else {
      this.StatusConfig.Statuses[0].Style = "color: var(--module-title); background-color: var(--dropdown-bg)";
      this.StatusConfig.Statuses[1].Style = "color: var(--dropdown-bg); background-color: #C6C8D3";
    }
  }

  override title(): string {
    return `Activité : ${this.Label}`;
  }

  override description(): string {
    return `Description : ${this.Description}`;
  }
}
